// Destek/geri bildirim modülü paylaşılan sabitleri (backend supportRequest.service.js ile aynı olmalı)

// Geri bildirimlerle ilgilenen kullanıcı — badge/menü yalnızca bu kişide görünür
export const FEEDBACK_HANDLER_EMAIL = 'cihancan.mustaoglu@aynetteknoloji.com.tr';
export const isFeedbackHandler = (email?: string | null): boolean =>
  !!email && email.trim().toLowerCase() === FEEDBACK_HANDLER_EMAIL;

export type SupportOption = { value: string; label: string; color: string; icon?: string };

export const CATEGORY_OPTIONS: SupportOption[] = [
  { value: 'bug', label: 'Hata', color: 'danger', icon: 'bi-bug' },
  { value: 'suggestion', label: 'Öneri', color: 'warning', icon: 'bi-lightbulb' },
  { value: 'question', label: 'Soru', color: 'info', icon: 'bi-question-circle' },
  { value: 'other', label: 'Diğer', color: 'secondary', icon: 'bi-chat-dots' },
];

export const PRIORITY_OPTIONS: SupportOption[] = [
  { value: 'low', label: 'Düşük', color: 'secondary' },
  { value: 'medium', label: 'Orta', color: 'primary' },
  { value: 'high', label: 'Yüksek', color: 'warning' },
  { value: 'urgent', label: 'Acil', color: 'danger' },
];

export const STATUS_OPTIONS: SupportOption[] = [
  { value: 'open', label: 'Açık', color: 'primary' },
  { value: 'in_progress', label: 'İncelemede', color: 'info' },
  { value: 'resolved', label: 'Çözüldü', color: 'success' },
  { value: 'rejected', label: 'Reddedildi', color: 'danger' },
  { value: 'closed', label: 'Kapatıldı', color: 'dark' },
];

export const optLabel = (opts: SupportOption[], value: string): string => opts.find((o) => o.value === value)?.label || value || '';
export const optColor = (opts: SupportOption[], value: string): string => opts.find((o) => o.value === value)?.color || 'secondary';
export const optIcon = (opts: SupportOption[], value: string): string => opts.find((o) => o.value === value)?.icon || '';

export const formatDate = (value?: string): string => {
  if (!value) return '';
  try {
    return new Date(value).toLocaleString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (e) {
    return value;
  }
};
